import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  icon: {
    width: 'auto',
    height: 40,
  },
});

const LogoMake = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.icon}
      src="https://cdn.make.com/img/make/make_app_white_logo.png"
      alt="Make Logo"
    />
  );
};

export default LogoMake;
